import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components/macro';
import Waypoint from '../Waypoint';
import Container from '../Container';
import Img from '../Image';
// import CustomBarChart from './CustomBarChart';

export const MediaBlock = styled.div`
  width: 100%;
  margin: ${props => (props.margin ? '0' : '2em')} auto;
  padding-bottom: ${props => (props.isLastItem ? '2em' : 0)};
`;

const ImageContainer = styled.div`
  /* display: flex;
  justify-content: ${props => props.alignment}; */
`;

const drawLine = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

const StyledSvg = styled.div`
  width: ${props => props.size};
  margin: 0 auto;
  ${({ alignment }) =>
    alignment && alignment.toLowerCase() === 'left'
      ? css`
          margin-left: 0;
        `
      : alignment && alignment.toLowerCase() === 'right'
      ? css`
          margin-right: 0;
        `
      : null}

  svg {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    ${props =>
      !!props.isIe11 && !!props.svgHeight && `height: ${props.svgHeight}px;`};
  }

  polyline,
  line {
    ${props =>
      !props.isIe11 &&
      props.animateLines &&
      'stroke-dasharray: 1000; stroke-dashoffset: 1000;'};
    ${props =>
      !props.isIe11 &&
      props.shouldAnimate &&
      css`
        animation: ${drawLine} 2s linear forwards;
      `};
  }

  polygon.arrow-point {
    opacity: 0;
    transition: opacity 0.4s ease 1.4s;

    ${props =>
      !props.isIe11 &&
      props.shouldAnimate &&
      css`
        opacity: 1;
      `};
  }
`;

const Image = styled(Img)`
  width: ${props => props.size};
  margin: 0 auto;
  ${({ alignment }) =>
    alignment && alignment.toLowerCase() === 'left'
      ? css`
          margin-left: 0;
        `
      : alignment && alignment.toLowerCase() === 'right'
      ? css`
          margin-right: 0;
        `
      : null}
`;

const Media = ({ fields, isNested, ...rest }) => {
  const { image, width, alignment, removeContainer, animateLines } = fields;
  const [svg, getSvg] = useState('');
  const [shouldAnimate, setAnimate] = useState(false);

  useEffect(() => {
    async function fetchData() {
      await fetch(image.fields.file.url)
        .then(response => response.text())
        .then(body => getSvg(body));
    }
    image.fields.file.url && fetchData();
  }, [image.fields.file.url]);

  const alt = image.fields && (image.fields.description || image.fields.title);

  const isIe11 = !!(window.navigator.userAgent.indexOf('Trident/') > -1);

  /** IE fallback to add a height to svg elements */
  const svgHeightMatch = isIe11 && svg && svg.match(/height="(\d+\.?\d.)"/);
  const svgHeight =
    svgHeightMatch && svgHeightMatch.length && svgHeightMatch[1];

  return (
    <Waypoint
      topOffset="0"
      bottomOffset="35%"
      onEnter={() => setAnimate(true)}
      onLeave={() => setAnimate(false)}
    >
      <MediaBlock
        margin={removeContainer}
        isLastItem={rest.index + 1 === rest.numberOfBlocks}
      >
        <Container fullWidth={removeContainer}>
          <ImageContainer>
            {image.fields.file.contentType === 'image/svg+xml' ? (
              <StyledSvg
                alt={alt}
                alignment={alignment}
                size={width}
                animateLines={animateLines}
                shouldAnimate={shouldAnimate}
                dangerouslySetInnerHTML={{ __html: svg }}
                isIe11={isIe11}
                svgHeight={svgHeight}
              />
            ) : (
              <Image
                src={image.fields.file.url}
                alt={alt}
                alignment={alignment}
                size={width}
              ></Image>
            )}
          </ImageContainer>
          {/* <CustomBarChart /> */}
        </Container>
      </MediaBlock>
    </Waypoint>
  );
};

Media.propTypes = {
  fields: PropTypes.shape({
    image: PropTypes.shape({
      sys: PropTypes.shape({}),
      fields: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
          contentType: PropTypes.string,
        }),
        title: PropTypes.string,
      }),
    }).isRequired,
    width: PropTypes.string,
    justifyContent: PropTypes.string,
  }).isRequired,
  isNested: PropTypes.bool,
};

Media.defaultProps = {
  fields: {
    width: '100%',
    justifyContent: 'flex-start',
  },
  isNested: true,
};

export default Media;
